import Vue from 'vue'
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue';
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'
// import $ from 'jquery'
import axios from "axios";
import JsonExcel from 'vue-json-excel'
import vSelect from 'vue-select'
import Header from "../../components/Header.vue";
import moment from "moment";
import ExportExcel from "../../components/ExportExcel.vue";
import CardSuivieTransportConventionnel
    from "../../components/cardSuivieTransportConventionnel/CardSuivieTransportConventionnel.vue";
import CardSuivieConventionnel from "../../components/CardSuivieConventionnel.vue";

Vue.component('downloadExcel', JsonExcel)
Vue.component('v-select', vSelect)


export default {
    components: {
        ExportExcel,
        Header,
        Vuetable,
        VuetablePagination,
        VuetableFieldCheckbox,
        VuetableFieldMixin,
        CardSuivieTransportConventionnel,
        CardSuivieConventionnel
    },
    data: function() {
        return {
            pageTitle: "Liste des tresoreries",
            type_submit :"insertion",
            dateOptions:{
                format: 'DD/MM/YYYY'
            },
            filtre: {
                recherche: '',
                start_date: moment().startOf('month').format('DD/MM/YYYY'),
                end_date:  moment().endOf('month').format('DD/MM/YYYY'),
                nom_client: '',
                criteriacol: '',
                current_page: 1,
                per_page: 20,
                last_page: 1,
                sort: "nom_navire|asc"
            },
            paginationCss: {
                infoClass: 'pull-left ',
                wrapperClass: 'vuetable-pagination text-center',
                activeClass: 'btn-secondary',
                disabledClass: 'disabled',
                pageClass: 'btn btn-border',
                linkClass: 'btn btn-border',
                icons: {
                    first: '',
                    prev: '',
                    next: '',
                    last: '',
                },
            },

            shipsData: [
                {
                    id: 1,
                    name: 'ATLANTIC EXPRESS',
                    bls: [
                        { bl: 'AX789012', total: 50000 },
                        { bl: 'AX789013', total: 60000 },
                        { bl: 'AX789014', total: 40000 }
                    ],
                    color: 'green'
                },
                {
                    id: 2,
                    name: 'OCEAN SURVEYOR',
                    bls: [
                        { bl: 'OS345678', total: 45000 },
                        { bl: 'OS345679', total: 50000 }
                    ],
                    color: 'green'
                },
            ],
            trackingDetails: {
                ship: '',
                bl: ''
            },
            // Exemple de données de suivi (simulées)
            trackingData: {
                'AX789012': [
                    { date: '2024-10-20', event: 'Chargé au port de Shanghai' },
                    { date: '2024-10-22', event: 'Départ du port de Shanghai' },
                    { date: '2024-10-28', event: 'En transit: Océan Pacifique' }
                ],
                'OS345678': [
                    { date: '2024-10-21', event: 'Chargé au port de Rotterdam' },
                    { date: '2024-10-23', event: 'Départ du port de Rotterdam' }
                ],
                'PP901234': [
                    { date: '2024-10-25', event: 'Chargé au port de Singapour' }
                ]
                // ... ajoutez d'autres données de suivi pour vos BLs
            }
        }
    },
    methods: {
        fetchTransporteur(recherche){
            const formmulaire = new FormData();
            formmulaire.append("recherche", recherche);

            axios.post(this.BASE_URL + "/suivietransport/fetch", formmulaire)
                .then((response) => {
                    this.list_transporteur = response.data;
                })
                .catch((err) => console.error(err));
        },

        fetchNavire(){
            console.log("Fetching ships with filter:", this.filtre);
            axios.get(this.BASE_URL + "/navire/fetchall", {
                    params: {
                        page: this.filtre.current_page,
                        per_page: this.filtre.per_page,
                        filter: this.filtre.recherche,
                        sort: this.filtre.sort,
                        start_date: this.filtre.start_date,
                        end_date: this.filtre.end_date,
                        criteriacol: this.filtre.criteriacol,
                    }
                })
                .then(responses => {
                    this.shipsData = responses.data.data;
                    this.filtre.current_page = parseInt(responses.data.current_page);
                    this.filtre.last_page = parseInt(responses.data.last_page);
                    this.filtre.per_page = parseInt(responses.data.per_page) || this.filtre.per_page;

                    this.$nextTick(() => {
                        if (this.$refs.pagination) {
                            this.$refs.pagination.setPaginationData({
                                current_page: this.filtre.current_page,
                                last_page: this.filtre.last_page,
                                per_page: this.filtre.per_page,
                                total: parseInt(responses.data.total),
                            });
                        }
                    });

                    this.syncFiltersToUrl();
                })
                .catch(err => console.error(err));
        },

        onChangePage(page) {
            let target = page;
            if (page === 'next') target = this.filtre.current_page + 1;
            else if (page === 'prev') target = this.filtre.current_page - 1;
            target = Math.min(Math.max(target, 1), this.filtre.last_page || 1);

            if (target === this.filtre.current_page) return;
            this.filtre.current_page = target;
            this.fetchNavire();
        },

        syncFiltersToUrl() {
            const query = {};
            if (this.filtre.recherche !== "") query.filter = this.filtre.recherche;
            if (this.filtre.criteriacol !== "") query.criteriacol = this.filtre.criteriacol;
            if (this.filtre.nom_client !== "") query.nom_client = this.filtre.nom_client;
            if (this.filtre.start_date !== "") query.start_date = this.filtre.start_date;
            if (this.filtre.end_date !== "") query.end_date = this.filtre.end_date;
            if (parseInt(this.filtre.current_page) > 1) query.page = String(this.filtre.current_page);

            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                this.$router.replace({ query }).catch(() => {});
            }
        },


        openDetail(data){
            this.$router.push({
                name: 'DetailsSuivieEnlevement',
                params: {
                    id_navire: data.ship.id_navire,
                    num_bl: encodeURIComponent(data.ship.num_bl)
                }
            });
        },

        setFilter() {
            this.filtre.current_page = 1;
            this.fetchNavire();
        },
        resetFilter() {
            this.filtre= {
                recherche: '',
                start_date: moment().startOf('month').format('DD/MM/YYYY'),
                end_date:  moment().endOf('month').format('DD/MM/YYYY'),
                nom_client: '',
                criteriacol: '',
                page: this.filtre.current_page,
                sort: this.filtre.sort,
                current_page: 1,
                per_page: 20,
                last_page: 1,
            };
            this.setFilter();
        },


    },

    created: function() {
        this.$emit('change-page', this.pageTitle);
        const query = this.$route.query;
        this.filtre = {
            recherche: query.filter || "",
            start_date: query.start_date || moment().startOf('month').format('DD/MM/YYYY'),
            end_date: query.end_date || moment().endOf('month').format('DD/MM/YYYY'),
            nom_client: query.nom_client || "",
            criteriacol: query.criteriacol || "",
            current_page: parseInt(query.page) > 0 ? parseInt(query.page) : 1,
            per_page: 20,
            last_page: 1,
            sort: "nom_navire|asc",
        };
    },
    mounted: function() {
        this.fetchNavire();

    }
}
